<div class="main">
    <div class="section">
        <div class="container">
            <div class="row">
                <div class="col-md-12 ml-auto mr-auto text-center">
                    <h2 class="title">Get in touch with us</h2>
                </div>
            </div>
            <div class="ml-auto mr-auto text-center align-items-center">
                <div class="row ml-auto mr-auto text-center">
                    <div class="col-md-3"></div>
                    <div class="col-md-3 ">
                        <div class="info text-center">
                            <div class="icon icon-primary">
                                <i class="nc-icon nc-support-17"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title"> Support </h4>

                            </div>
                        </div>
                    </div>

                    <div class="col-2 col-md-1 col-sm-1">

                        <div class="info">
                            <div class="description">
                                <h4 class="info-title btn-round"> <i  class="fa fa-phone me-3" style="color: #184685;" aria-hidden="true"></i> </h4>

                                            <h4 class="info-title"> <i  style="color: #25D366;" class="fa fa-whatsapp ps-3" aria-hidden="true"></i> </h4>

                                <h4 class="info-title">  <i  class="fa fa-envelope me-3" style="color: #184685;" aria-hidden="true"></i> </h4>
                                <h4 class="info-title">  <i  class="fa fa-envelope me-3 "  style="color: #184685;" aria-hidden="true"></i>  </h4>

                            </div>
                        </div>


                    </div>

                    <div class="col-8 col-md-4 col-sm-4 ">
                        <div class="info">
                            <div class="description text-left">
                                <h4 class="info-title"> <a class="link " style="color: #184685;" href="tel:0860 018 363"><strong>0860
                                            018 363</strong> </a></h4>

                                            <h4 class="info-title"> <a class=" ms-2 link" style="color: #184685;" href="https://wa.me/27660497922"><strong>0660 497 922</strong> </a> </h4>

                                <h4 class="info-title"> <a class="link " style="color: #184685;" href="mailto:support@e-md.co.za"><strong>support@e-md.co.za</strong> </a></h4>
                                <h4 class="info-title"> <a class="link " style="color: #184685;" href="mailto:sales@e-md.co.za"><strong>sales@e-md.co.za</strong></a> </h4>

                            </div>
                        </div>
                    </div>
                    
                </div>

            </div>

            <div class="row">
                <div class="col-md-6 ml-auto mr-auto text-center">
                    <h3 class="title"><small>Find us on social networks</small></h3>


                    <ng-container *ngFor="let social of socialData">

                        <ng-container *ngIf="social.icon=='whatsapp'; else elseTemplate">
                            <a href="{{social.url}}" class="btn btn-just-icon btn-round btn-{{social.icon}} mr-1"
                                style="background-color: #25D366; border-color: #25D366;" target="_blank">
                                <i  class="fa fa-{{social.icon}} text-white" aria-hidden="true"></i> </a>
                        </ng-container>
                        <ng-template #elseTemplate>
                            <a href="{{social.url}}" class="btn btn-just-icon btn-round btn-{{social.icon}} mr-1"
                                target="_blank">
                                <i class="fa fa-{{social.icon}}" aria-hidden="true"></i> </a>
                        </ng-template>




                    </ng-container>

                    <!-- <button class="btn btn-just-icon btn-twitter mr-1">
                        <i class="fa fa-twitter"></i>
                    </button>
                    <button class="btn btn-just-icon btn-facebook mr-1">
                        <i class="fa fa-facebook"></i>
                    </button>
                    <button class="btn btn-just-icon btn-google mr-1">
                        <i class="fa fa-google"></i>
                    </button>
                    <button class="btn btn-just-icon btn-dribbble mr-1">
                        <i class="fa fa-dribbble"></i>
                    </button>
                    <button class="btn btn-just-icon btn-instagram mr-1">
                        <i class="fa fa-instagram"></i>
                    </button>
                    <button class="btn btn-just-icon btn-youtube">
                        <i class="fa fa-youtube"></i>
                    </button> -->
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 ml-auto mr-auto text-center">
                    <h3 class="title"><small>or send us a message</small></h3>
                    <form [formGroup]="contactUsForm" class="contact">

                        <input formControlName="website" type="text" autocomplete="off" tabindex="-1"
                            aria-hidden="true"
                            style="position:absolute;left:-9999px;width:1px;height:1px;opacity:0;">

                        <div class="row">
                            <div class="col-md-6">
                                <input formControlName="practice_number" type="text" class="form-control"
                                    placeholder="Practice Number">

                            </div>
                            <!-- <div class="col-md-6">
                                <input type="text" class="form-control" placeholder="Last Name">
                            </div> -->
                        </div>

                        <div class="row">
                            <div class="col-md-6">

                                <input formControlName="first_name" type="text" class="form-control"
                                    placeholder="First Name"> <small
                                    *ngIf="f['first_name'].errors && f['first_name'].errors.required"
                                    class="text-danger form-text text-muted mt-n3 text-right">*Required!</small>
                            </div>
                            <div class="col-md-6">

                                <input formControlName="last_name" type="text" class="form-control"
                                    placeholder="Last Name"> <small
                                    *ngIf="f['last_name'].errors && f['last_name'].errors.required"
                                    class="text-danger form-text text-muted mr-auto mt-n3 text-right">*Required!</small>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">

                                <input formControlName="email" type="text" class="form-control"
                                    placeholder="Email"><small *ngIf="f['email'].errors && f['email'].errors.required"
                                    class="text-danger form-text text-muted mt-n3 text-right">*Required!</small>
                            </div>
                            <div class="col-md-6">

                                <input formControlName="mobile" type="text" class="form-control" placeholder="Mobile">
                                <small *ngIf="f['mobile'].errors && f['mobile'].errors.required"
                                    class="text-danger form-text text-muted mt-n3 text-right">*Required!</small>
                            </div>
                        </div>



                        <div class="row align-items-center mb-2">

                            <div class="col-md-6 mr-auto">
                                Department <select formControlName="selected_department"
                                    class="dropdown w-100 form-control" id="selected_department">

                                    <option value="sales">
                                        Sales</option>

                                    <option value="support">
                                        Support</option>

                                </select>
                            </div>

                            <div class="col-md-6">

                                Region <select formControlName="selected_region" class="dropdown w-100 form-control"
                                    id="selected_region">
                                    <option value="Eastern Cape">
                                        Eastern Cape</option>
                                    <option value="Free State">
                                        Free State</option>
                                    <option value="Gauteng">
                                        Gauteng</option>
                                    <option value="KwaZulu-Natal">
                                        KwaZulu-Natal</option>
                                    <option value="Limpopo">
                                        Limpopo</option>
                                    <option value="Mpumalanga">
                                        Mpumalanga</option>
                                    <option value="Northern Cape">
                                        Northern Cape</option>
                                    <option value="North West">
                                        North West</option>
                                    <option value="Western Cape">
                                        Western Cape</option>

                                </select>
                                <small *ngIf="f['selected_region'].errors && f['selected_region'].errors.required"
                                    class="text-danger form-text text-muted mt-n3 text-right">*Required!</small>
                            </div>

                        </div>



                        <div class="row">

                            <div class="col-md-12">

                                <input formControlName="subject" type="text" class="form-control"
                                    placeholder="Subject"><small
                                    *ngIf="f['subject'].errors && f['subject'].errors.required"
                                    class="text-danger form-text text-muted mt-n3 text-right">*Required!</small>
                            </div>
                        </div>

                        <textarea formControlName="message" class="form-control" placeholder="Message"
                            rows="9"></textarea> <small *ngIf="f['message'].errors && f['message'].errors.required"
                            class="text-danger form-text text-muted mt-n3 text-right">*Required!</small>

                        <div class="row">
                            <div class="col-md-6 ml-auto mr-auto">

                                <div *ngIf="contactUsForm.valid == true">

                                    <button (click)="open(classic, '')" class="btn btn-primary btn-block btn-round">Send
                                    </button>

                                </div>

                                <div *ngIf="contactUsForm.valid == false">

                                    <button disabled class="btn btn-primary btn-block btn-round">Send </button>

                                </div>

                                <!-- <div>
                {{contactUsForm.getRawValue() | json}} <br>
                {{contactUsForm.valid | json}} <br>
            </div> -->

                            </div>
                        </div>
                    </form>
                    <h3 class="visit"><small>Our Offices</small></h3>
                </div>
            </div>





            <!--     *********     BLOGS 2      *********      -->

            <div class="blog-2 section">
                <div class="container">
                    <div class="row">
                        <div class="col-md-10 ml-auto mr-auto">

                            <div class="row align-items-center align-content-center">

                                <div class="w-100" *ngFor="let branch of branchData">

                                    <div class="col-md-12">
                                        <div class="card card-blog w-100">

                                            <div class="card-body w-100">
                                                <h3 class="card-category text-primary"> <i class="nc-icon nc-pin-3"></i>
                                                    {{branch.name}}</h3>
                                                <h5 class="card-title">
                                                    <a href="javascript:void(0)"></a>
                                                </h5>
                                                <p class="card-description">
                                                    {{branch.address}} <br />
                                                </p>
                                                <p class="card-description">
                                                    Latitude: {{branch.latitude}} <br />
                                                </p>
                                                <p class="card-description">
                                                    Longitude: {{branch.longitude}} <br />
                                                </p>
                                                <hr>
                                                <google-map height="400px" width="100%"
                                                    [center]="getPosition(branch.latitude, branch.longitude)"
                                                    [zoom]="zoom">
                                                    <map-marker
                                                        [position]="getPosition(branch.latitude, branch.longitude)"></map-marker>
                                                </google-map>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>
            </div>





            <ng-template #classic let-c="close" let-d="dismiss">
                <ng-container *ngIf="submitState === 'pending'">
                    <div class="modal-body text-center py-4">
                        <div class="spinner-border text-primary mb-3" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <p class="mb-0">Submitting your request&hellip;</p>
                    </div>
                </ng-container>

                <ng-container *ngIf="submitState === 'success'">
                    <div class="modal-header">
                        <h5 class="modal-title text-center">Email Sent!</h5>
                        <button type="button" class="close" (click)="d('Cross click')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        Thank you, a email have been sent to relevant parties and we will contact you shortly.
                    </div>
                    <div class="modal-footer">
                        <div class="divider"></div>
                        <div class="right-side">
                            <button type="button" class="btn btn-success btn-link" (click)="c('Close click')">Ok</button>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="submitState === 'error'">
                    <div class="modal-header">
                        <h5 class="modal-title text-center text-danger">Submission failed</h5>
                        <button type="button" class="close" (click)="d('Cross click')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        We couldn't submit your request. Please check your connection and try again, or contact us directly.
                    </div>
                    <div class="modal-footer">
                        <div class="divider"></div>
                        <div class="right-side">
                            <button type="button" class="btn btn-danger btn-link" (click)="c('Close click')">Close</button>
                        </div>
                    </div>
                </ng-container>
            </ng-template>

        </div>
    </div>
</div>